import { Loader2 } from 'lucide-react';
import type { ComponentProps } from 'react';
import { Button } from '@/components/ui/button';

export function LoadingButton({ loading, disabled, children, ...rest }: ComponentProps<typeof Button> & { loading?: boolean }) {
  return (
    <Button {...rest} disabled={disabled || loading}>
      {loading && <Loader2 className="animate-spin" />}
      {children}
    </Button>
  );
}
